
import { Button } from "@/components/ui/button"
import { useToast } from "@/components/ui/use-toast"
import { useState } from "react"

interface AIFollowUpQuestionsProps {
  followUp: string[]
}

export function AIFollowUpQuestions({ followUp }: AIFollowUpQuestionsProps) {
  const { toast } = useToast()
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null)
  
  const handleCopyQuestion = (question: string, index: number) => {
    navigator.clipboard.writeText(question).then(() => {
      toast({
        title: "Question copied",
        description: "The question has been copied to your clipboard",
      })
      setCopiedIndex(index)
      setTimeout(() => setCopiedIndex(null), 2000)
    })
  }
  
  if (!followUp || followUp.length === 0) return null
  
  return (
    <div className="space-y-2">
      <h4 className="font-medium text-sm text-[#FFC745]">Suggested Follow-up Questions</h4>
      <div className="space-y-2">
        {followUp.map((question, index) => (
          <div key={index} className="bg-[#FFC745]/10 p-3 rounded-md border border-[#FFC745]/20">
            <p className="text-xs text-[#FFC745] mb-2">{question}</p>
            <Button 
              size="sm" 
              variant="outline" 
              className="text-xs h-7 bg-transparent border-[#FFC745]/30 text-[#FFC745] hover:bg-[#FFC745]/10"
              onClick={() => handleCopyQuestion(question, index)}
            >
              {copiedIndex === index ? "Copied!" : "Copy to clipboard"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  )
}
